'use client';

import {SocialNetworks} from 'components/social-networks';
import {useParams} from 'next/navigation';
import styles from './social-networks-layout.module.scss';

export const SocialNetworksLayout = () => {

    /* при условии если мы посещаем страницу с указанным маршрутом
    * социальные сети рендерятся не футтере а над описаение
    * открытой страницы*/

    // const params = useParams().slug;

    return (
        <>
            {/*{!params && (*/}
            <aside className={styles.wrap}>
                <SocialNetworks/>
            </aside>
            {/*)}*/}
        </>
    );
};
